import { render, staticRenderFns } from "./rp-roles-datasources-list.vue?vue&type=template&id=7e868c5a"
import script from "./rp-roles-datasources-list.vue?vue&type=script&lang=js"
export * from "./rp-roles-datasources-list.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-datasources-list.vue?vue&type=style&index=0&id=7e868c5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports